import { render, staticRenderFns } from "./detail-sel.vue?vue&type=template&id=ade890e6&scoped=true"
import script from "./detail-sel.vue?vue&type=script&setup=true&lang=js"
export * from "./detail-sel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail-sel.vue?vue&type=style&index=0&id=ade890e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade890e6",
  null
  
)

export default component.exports